import type { ModelTier } from '../domain/types'

const TIER_RANK: Readonly<Record<ModelTier, number>> = {
  direct: 0,
  standard: 1,
  deep: 2,
}

export function modelMeetsRouteFloor(
  modelTier: ModelTier,
  routeTier: ModelTier,
): boolean {
  return TIER_RANK[modelTier] >= TIER_RANK[routeTier]
}
